<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton 
                :showBtn="false"
                title="Loan Register List"
                btnTitle="Add New"
                :showAddNew="true"
                @onClickAddNewButton="onClickAddNewButton"
            />
        </div>
        <div class="col-12 px-2 mt-2 mb-4">
          <div class="card p-2" style="min-height: 200px">
            <div class="table-responsive">
              <table class="table">
                <thead>
                <tr>
                  <th>SL</th>
                  <th class="text-center">Employee Name</th>
                  <th class="text-center">Loan Amount</th>
                  <th class="text-center">Number Of Installment</th>
                  <th class="text-center">Installment Interval</th>
                  <th class="text-center">Interest Method</th>
                  <th class="text-center">Interest Percentage</th>
                  <th class="text-center">Total Interest Amount</th>
                  <th class="text-center">Installment Principle Amount</th>
                  <th class="text-center">Installment Interest Amount</th>
                  <th class="text-center">Installment Amount</th>
                  <th class="text-center">Total Adjustment Amount</th>
                  <th class="text-center">Total Interest Adjustment Amount</th>
                  <th class="text-center">Installment Start Date</th>
                  <th class="text-center">Installment End Date</th>
                  <th class="text-center">Status</th>
                  <th class="text-center">Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in tableItems.data" :key="i">
                  <td>{{ i + 1 + ((tableItems.current_page - 1) * parseInt(tableItems.per_page)) }}</td>
                  <td class="text-center">{{ item.employee_name }}</td>
                  <td class="text-center">{{ item.loan_amount }}</td>
                  <td class="text-center">{{ item.number_of_installment }}</td>
                  <td class="text-center">{{ item.installment_interval_name }}</td>
                  <td class="text-center">{{ item.interest_method_name }}</td>
                  <td class="text-center">{{ item.interest_percentage }}</td>
                  <td class="text-center">{{ item.total_interest_amount }}</td>
                  <td class="text-center">{{ item.installment_principal_amount }}</td>
                  <td class="text-center">{{ item.installment_interest_amount }}</td>
                  <td class="text-center">{{ item.installment_amount }}</td>
                  <td class="text-center">{{ item.total_adjustment_amount }}</td>
                  <td class="text-center">{{ item.total_adjustment_interest_amount }}</td>
                  <td class="text-center">{{ item.installment_start_date }}</td>
                  <td class="text-center">{{ item.installment_end_date }}</td>
                  <td class="text-center">{{ item.status_name }}</td>
                  <td class="text-center">
                    <button class="btn btn-primary btn-sm mb-1 mx-1"
                            @click="goToEdit(item)"
                            style="cursor: pointer"
                    >
                      <i class="fas fa-pencil-alt"></i>
                    </button>

                    <button class="btn btn-success btn-sm"
                            @click="loanStatement(item)"
                            style="cursor: pointer"
                    >
                      <i class="fas fa-eye"></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
              <p v-if="tableItems.data && tableItems.data.length < 0" class="text-center mt-5">No data</p>
            </div>
          </div>
        </div>

        <div class="px-2 position-absolute bottom-0 mt-4">
            <Pagination :offset="params.offset" @onPageChange="onPageChange" ref="pagination"/>
        </div>

      <LoanStatementModal
          v-if="store.state.isModalOpenTwo"
          :loanStatementData="loanStatementData"
      />

        <Loader v-if="loading"/>

    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import { inject, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import Pagination from '@/components/atom/Pagination'
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import { computed } from 'vue';
import LoanStatementModal from "@/components/molecule/company/hrm-payroll/loan-register/StatementModal.vue";

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const tableItems = ref([]);
const loanStatementData = ref([]);
const params = ref({
    offset: 20,
});

const token = computed(() => localStorage.getItem('token'));

const {
  fetchLoanRegister,
  fetchLoanRegisterStatement
} = handleHrPayroll()

const loanStatement = async (item) => {
  let query = `?company_id=${route.params.companyId}`;

  await fetchLoanRegisterStatement(item.id, query).then((res) => {
    if (!res.status) {
      showError(res.message)
      return
    }
    loanStatementData.value = res.data;
  })

  store.state.isModalOpenTwo = true
}

function onClickAddNewButton() {
  router.push({name: `loan-registers-add`, params: route.params, query: route.query})
}

const setPaginationData = (data) => {
    store.commit('setPaginationData', data)
};

const setPagination = (data) => {
    setPaginationData({
        records: data.total,
        perPage: data.per_page,
        currentPage: data.current_page,
    })
}

const onPageChange = async (page) => {
    let routeQuery = Object.assign({}, route.query)
    routeQuery.page = page
    await router.push({path: route.path, query: routeQuery})
    await getLoanRegister();
}

const goToEdit = (item) => {
  let param = {
    companyId: route.params.companyId,
    moduleId: route.params.moduleId,
    menuId: route.params.menuId,
    pageId: route.params.pageId
  }

  let query = route.query;
  query.loanRegisterId = item.id;

  router.push({
    name:  'loan-registers-add',
    params: param,
    query: query
  })
}

const getLoanRegister = async () => {
    const query = getQuery();
    loading.value = true
    tableItems.value = []

    await fetchLoanRegister(query).then(res => {
        if (!res.status){
            store.commit("resetPagination")
            return
        }
        tableItems.value = res.data;
        setPagination(res.data)
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const getQuery = () => {
    let query = `?company_id=${route.params.companyId}`;
    if (route.query.page) query += '&page=' + route.query.page;
    query += '&offset=' + params.value.offset
    return query;
}

onMounted(() => {
    Promise.all([
      getLoanRegister(),
    ])
})
</script>
